/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  order.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:31
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

const orderRouter = [
  {
    path: '/salesOrderList',
    name: 'SalesOrderList',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/SalesOrder/index.vue'),
    meta: {
      title: '销售单管理',
      keepAlive: true,
      deepth: 1,
      permission: true
    }
  },
  {
    path: '/purchaseOrderList',
    name: 'PurchaseOrderList',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/PurchaseOrder/index.vue'),
    meta: {
      title: '采购单管理',
      keepAlive: true,
      deepth: 1,
      permission: true
    }
  },
  // 采购订单详情
  {
    path: '/purchaseOrderDetail',
    name: 'purchaseOrderDetail',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/PurchaseOrder/purchaseOrderDetail.vue'),
    meta: {
      title: '订单详情',
      keepAlive: true,
      deepth: 3,
      permission: true
    },
  },
  // 采购退单详情
  {
    path: '/purchaseOrderReturnDetail',
    name: 'purchaseOrderReturnDetail',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/PurchaseOrder/purchaseOrderReturnDetail.vue'),
    meta: {
      title: '退单详情',
      keepAlive: true,
      deepth: 3,
      permission: true
    },
  },
  // 销售订单详情
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/SalesOrder/OrderDetail.vue'),
    meta: {
      title: '订单详情',
      keepAlive: true,
      deepth: 3,
      permission: true
    },
  },
  // 销售退单详情
  {
    path: '/orderReturnDetail',
    name: 'orderReturnDetail',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/SalesOrder/OrderReturnDetail.vue'),
    meta: {
      title: '退单详情',
      keepAlive: true,
      deepth: 3,
      permission: true
    },
  },
  {
    path: '/remarks',
    name: 'Remarks',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/subPage/Remarks.vue'),
    meta: {
      title: '备注',
      keepAlive: true,
      deepth: 4
    },
  },
  {
    path: '/addRemark',
    name: 'AddRemark',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/subPage/AddRemark.vue'),
    meta: {
      title: '添加备注',
      deepth: 6
    },
  },
  {
    path: '/log',
    name: 'Log',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/subPage/Log.vue'),
    meta: {
      title: '订单日志',
      deepth: 4
    },
  },
  {
    path: '/valetOrder',
    name: 'ValetOrder',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/ValetOrder/index.vue'),
    meta: {
      title: '代客下单',
      keepAlive: true,
      deepth: 3
    },
  },
  {
    path: '/chooseCustomer',
    name: 'ChooseCustomer',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/ValetOrder/ChooseCustomer.vue'),
    meta: {
      title: '选择客户',
      deepth: 5
    },
  },
  {
    path: '/chooseGoods',
    name: 'ChooseGoods',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/ValetOrder/ChooseGoods.vue'),
    meta: {
      title: '选择商品',
      // keepAlive: true,
      deepth: 5
    },
  },
  {
    path: '/searchGoodList',
    name: 'SearchGoodList',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/ValetOrder/SearchGoodList.vue'),
    meta: {
      title: '搜索商品',
      deepth: 6
    },
  },
  {
    path: '/barCodeGoodList',
    name: 'BarCodeGoodList',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/ValetOrder/BarCodeGoodList.vue'),
    meta: {
      title: '扫一扫',
      deepth: 6
    },
  },
  {
    path: '/searchOrder',
    name: 'SearchOrder',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/subPage/SearchOrder.vue'),
    meta: {
      title: '搜索订单',
      keepAlive: true,
      deepth: 2
    },
  },
  //  销售单 带客退单
  {
    path: '/valetRefund',
    name: 'ValetRefund',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/SalesOrder/ValetRefund.vue'),
    meta: {
      title: '代客退货',
      deepth: 3
    },
  },
  // {
  //   path: '/salesSlip',
  //   name: 'salesSlip',
  //   component: () =>
  //           import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/SalesOrder/SalesSilp.vue'),
  //   meta: {
  //     title: '销售单',
  //     permission: true,
  //     deepth: 2
  //   },
  // },
  // {
  //   path: '/salespromotion',
  //   name: 'salespromotion',
  //   component: () =>
  //           import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/sales/SalesPromotion.vue'),
  //   meta: {
  //     title: '促销活动',
  //     deepth: 3
  //   },
  // },
  // {
  //   path: '/salesstatistics',
  //   name: 'salesstatistics',
  //   component: () =>
  //           import(/* webpackChunkName: "orderManage" */ '@/views/orderManage/sales/SalesStatistics.vue'),
  //   meta: {
  //     title: '销售统计',
  //     deepth: 3
  //   },
  // },
  {
    path: '/applyccxstore',
    name: 'applyccxstore',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/information/ApplyCCXStore.vue'),
    meta: {
      title: '申请开通常常鲜店铺',
      deepth: 3
    },
  },
  {
    path: '/applyccxstoredetails',
    name: 'applyccxstoredetails',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/information/ApplyCCXStoreDetails.vue'),
    meta: {
      title: '常常鲜店铺信息',
      deepth: 3
    },
  },
  {
    path: '/editCCXStore',
    name: 'EditCCXStore',
    component: () =>
            import(/* webpackChunkName: "orderManage" */ '@/views/information/EditCCXStore.vue'),
    meta: {
      title: '编常常鲜店铺信息',
      deepth: 3
    },
  },
]

export default orderRouter
